import { Pagination } from '@api/abstracts/models';
import { BlogArticle, BlogArticleDocument, ElasticSearchResponse } from '@shared/services/elastic-search/models';

export const blogArticlesSerializer = (
  blogArticles: ElasticSearchResponse<BlogArticleDocument>,
  size: number
): Pagination<BlogArticle> => {
  const items = blogArticles.hits.hits.map((blogArticle) => {
    const id = blogArticle._id;
    const source = blogArticle._source;
    return {
      id,
      url: source.url?.[0] ?? '',
      creationDate: source.created?.[0] ?? '',
      image: source.image?.[0] ?? null!,
      level2Category: source.name?.[0] ?? '',
      title: source.title?.[0] ?? '',
    };
  });
  return {
    items,
    currentPage: undefined!,
    itemsPerPage: size,
    totalItems: blogArticles.hits.total.value ?? 0,
    totalPages: undefined!,
  };
};
